import { useMutation, useQuery, useQueryClient } from 'react-query';
import { createWhatsAppChannel, listChannels, updateWhatsAppChannel, type SaveWhatsAppChannelRequest } from '@/services/channelsService';

export interface UseChannelsOptions {
  tenantId?: string;
  enabled?: boolean;
}

export function useChannels(options: UseChannelsOptions = {}) {
  const { tenantId, enabled = true } = options;

  return useQuery({
    queryKey: ['channels', { tenantId }],
    queryFn: async () => {
      const res = await listChannels({ tenant_id: tenantId });
      return res.data;
    },
    enabled,
  });
}

export function useSaveWhatsAppChannel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ channelId, payload }: { channelId?: string; payload: SaveWhatsAppChannelRequest }) => {
      const response = channelId
        ? await updateWhatsAppChannel(channelId, payload)
        : await createWhatsAppChannel(payload);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries('channels');
    },
  });
}
